import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import StorePresenter from '../../../../../presenters/StorePresenter';
import FormHeader from '../../../../../components/FormHeader';
import Group from '../../../../../components/Group';

import Offers from './components/Offers';
import MerchantNames from './components/MerchantNames';
import StoreInfo from './components/StoreInfo';
import FastCash from './components/FastCash';

export const UPCOMING_TAB = 'upcoming';
export const EXPIRED_TAB = 'expired';

const BrandInfo = (props) => {
  const { offers, match, brand } = props;

  const upcomingOffers = () => {
    const today = moment();
    return offers.filter((offer) => {
      const start = moment(offer.startDate);
      return today.isBefore(start);
    });
  };

  const activeOffers = () => {
    const upcoming = upcomingOffers();
    const expired = expiredOffers();

    return offers.filter(
      (offer) => !upcoming.includes(offer) && !expired.includes(offer)
    );
  };

  const expiredOffers = () => {
    const today = moment();
    return offers.filter((offer) => {
      const end = moment(offer.endDate);
      return today.isAfter(end);
    });
  };

  const displayedOffers = () => {
    const {
      params: { offersTab },
    } = match;

    switch (offersTab) {
      case UPCOMING_TAB:
        return upcomingOffers();
      case EXPIRED_TAB:
        return expiredOffers();
      default:
        return activeOffers();
    }
  };

  return (
    <div className="store">
      <FormHeader title="Brand Details">
        <Link
          to={`/brands/${StorePresenter.id(brand)}/edit`}
          className="button"
        >
          Edit Brand
        </Link>
      </FormHeader>
      <StoreInfo brand={brand} />
      <Group>
        <FastCash brand={brand} />
        <MerchantNames brand={brand} />
        <Offers
          brand={brand}
          upcomingTab={UPCOMING_TAB}
          expiredTab={EXPIRED_TAB}
          displayedOffers={displayedOffers()}
        />
      </Group>
    </div>
  );
};

export default BrandInfo;
